import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { handleSafeAppTransaction } from 'modules/api/methods/handleSafeAppTransaction';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';
import { queryFnNotifyWrapper } from 'modules/common/utils/queryFnNotifyWrapper';

import { delegate } from '../methods/delegate';

interface IDelegateArgs {
  poolAddress: Address;
  amount: BigNumber;
}

export const { useDelegateMutation } = api.injectEndpoints({
  endpoints: build => ({
    delegate: build.mutation<boolean, IDelegateArgs>({
      queryFn: queryFnNotifyWrapper<IDelegateArgs, void, boolean>(
        async ({ amount, poolAddress }, { dispatch }) => {
          const walletClient = getWalletClient();
          const publicClient = getPublicClient();

          const txPromise = delegate(walletClient, {
            poolAddress,
            amount,
          });

          await handleSafeAppTransaction({
            txPromise,
            dispatch,
            publicClient,
            accountAddress: asAddress(walletClient.account?.address),
          });

          return {
            data: true,
          };
        },
      ),
      invalidatesTags: [
        cacheTags.account,
        cacheTags.pools,
        cacheTags.allowance,
      ],
    }),
  }),
});
